import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { function_ } from '../../firebase';
import Image from 'react-bootstrap/Image';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';

class Commentary extends React.Component {
	state = {
		commentary: '',
		grade: 'ELIGE',
		send: false,
		message: ''
	};

	changeState = async (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value
		});
	};

	submitForm = async (e) => {
    const { commentary, grade } = this.state;

		this.setState({
			message: 'Tu mensaje fue enviado correctamente',
			send: true
    });
    
		setTimeout(
			() =>
				this.setState({
					message: ''
				}),
			3000
		);

		const callableReturnMessage = function_.httpsCallable('postSuggestion');

		const data_ = {
			shopUid: this.props.shopUid,
			grade,
			commentary
		};

		await callableReturnMessage(data_);
	};

	displayGrade = () => (
		<Fragment>
			<div className="form-group">
				<label>Nota</label>
				<select name="grade" className="form-control" onChange={this.changeState} value={this.state.grade}>
					<option value="ELIGE" disabled>
						{'Elige'}
					</option>

					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
					<option value="5">5</option>
					<option value="6">6</option>
					<option value="7">7</option>
				</select>
			</div>
		</Fragment>
	);

	render() {
		const { commentary, grade, send, message } = this.state;
		return (
			<Fragment>
				<Header/>
				<div className="col-md-3 offset-md-4" style={{ marginBottom: '80px' }}>
	
					<div className="row justify-content-center mt-2 mb-4">
						<Image style={{width: '100%', height: '40vh'}}  className="image-commentary" src={this.props.urlPhoto} roundedCircle />
					</div>

					<p className="ml-3 mr-3 mb-2">
						Ayúdanos dejando tu sugerencia o reclamo para poder mejorar nuestro servicio
					</p>
					<p className="ml-3 mr-3">
						! Muchas Gracias !
					</p>

					<div className="col-12">
						<textarea
							name="commentary"
							className="form-control"
							rows="5"
							placeholder="Deja tu comentario"
							onChange={this.changeState}
						/>
					</div>

					<div className="col-12 mt-3">
            {this.displayGrade()}
          </div>

					{message}

					<div className="col-12">
						<button
							className="btn"
							style={{ backgroundColor: this.props.shopColor, color: 'white' }}
							disabled={!commentary || grade === 'ELIGE' || send === true}
							onClick={(e) => this.submitForm(e)}
						>
							{' '}
							Enviar{' '}
						</button>
					</div>

				</div>
				<Footer />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	shopUid: state.shopUid,
	urlPhoto: state.urlPhoto,
	shopColor: state.shopColor
});

export default connect(mapStateToProps, {})(Commentary);
